/// <amd-module name="Wit/UI/Card/Components/WorkItemCardHeader/WorkItemCardHeader" />
import * as React from "react";
import { WorkItemTypeIcon, TypeIconSize } from "Wit/UI/WorkItemTypeIcon";
import { IWorkItemCardHeaderProps } from "./WorkItemCardHeader.Props";
import { Link } from "VSSUI/Link";

export class WorkItemCardHeader extends React.PureComponent<IWorkItemCardHeaderProps> {
    public render(): JSX.Element {
        const { id, href, typeColorAndIcon, openWorkItem, onRenderAdditionalInfoSection, showId, title } = this.props;

        return (
            <div className="work-item-card-header flex-column">
                <div className="work-item-card-header--info flex-row flex-grow flex-center">
                    {typeColorAndIcon && (
                        <div className="work-item-card-header--type-icon flex-row justify-center flex-center">
                            <WorkItemTypeIcon data={typeColorAndIcon} size={TypeIconSize.large} />
                        </div>
                    )}
                    {showId && <div className="work-item-card-header--id">#{id}</div>}
                    {onRenderAdditionalInfoSection && (
                        <>
                            {/* Spacer */}
                            <div className="flex-grow" />
                            {onRenderAdditionalInfoSection()}
                        </>
                    )}
                </div>
                {title && (
                    <Link className="work-item-card-title-link body-m flex-self-start fontWeightSemiBold" href={href} onClick={openWorkItem}>
                        {title}
                    </Link>
                )}
            </div>
        );
    }
}
